import {
    actionTypes
} from '../constants/actionTypes';

const initialState = {
    selectedApi: null,
    apiList: [],
    apiLogs: [],
    pages: 1,
    currentPage: 1,
    resultsCount: 0,
};

export default (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.getApiList:
            return {
                ...state,
                apiList: action.payload
            };
        case actionTypes.setSelectedApi:
            return {
                ...state,
                selectedApi: action.payload
            }
        case actionTypes.getApiLogs:
            return {
                ...state,
                apiLogs: action.payload
            }
        case actionTypes.saveApiLogPagination:
            return {
                ...state,
                pages : action.payload.pages,
                currentPage: action.payload.currentPage,
                resultsCount: action.payload.resultsCount
            };
        default:
            return state;
    }
}
